module.exports = __webpack_public_path__ + "img/6.cab252e0.jpg";